import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { WorkerListScreen } from './worker/list/WorkerListScreen';
import { WorkerUpdateScreen } from './worker/form/update/WorkerUpdateScreen';
import { MachineListScreen } from './machine/list/MachineListScreen';
import { MachineUpdateScreen } from './machine/form/update/MachineUpdateScreen';
import { DocumentsScreen } from './document/DocumentsScreen';
import { PsRoutes } from '../shared/routing/Routes';
import { WorkListScreen } from './work/list/WorkListScreen';
import { WorkListScreen as PresenceWorkListScreen } from "./presence/management/work/WorkListScreen";
import { WorkCreateScreen } from './work/form/create/WorkCreateScreen';
import { WorkUpdateScreen } from './work/form/update/WorkUpdateScreen';
import { PresenceAddScreen } from "./presence/management/add/PresenceAddScreen";
import OutsourcesScreen from "../outsource/screens/OutsourcesScreen";
import OutsourceDetailScreen from "../outsource/screens/OutsourceDetailScreen";
import AddOutsourceScreen from "../outsource/screens/AddOutsourceScreen";
import ExportOutsourceDocsConfirmScreen from "../outsource/screens/ExportOutsourceDocsConfirmScreen";
import ExportOutsourceDocsScreen from "../outsource/screens/ExportOutsourceDocsScreen";
import TypeDocumentsScreens from "../documents/screens/TypeDocumentsScreens";
import TypeDocumentDetailScreen from "../documents/screens/TypeDocumentDetailScreen";
import SchemesScreen from "../documents/screens/SchemesScreen";
import SchemesDocumentDetailScreen from "../documents/screens/SchemesDocumentDetailScreen";
import RemoveScreen from "../remove/screens/RemoveScreen";
import RemoveConfirmScreen from "../remove/screens/RemoveConfirmScreen";
import MonthlyScreen from "./monthly/screens/MonthlyScreen";
import {MonthlyPresenceScreen} from "./presence/monthly/MonthlyPresenceScreen";
import TasksScreen from "./tasks/list/screens/TasksScreen";
import PaperBinScreen from "../paperbin/screens/PaperBinScreen";
import { OutsourceDocumentDetailScreen } from './document/OutsourceDocumentDetailScreen';
import { WorkerDocumentDetailScreen } from './document/WorkerDocumentDetailScreen';
import { MachineDocumentDetailScreen } from './document/MachineDocumentDetailScreen';
import { TaskCreateScreen } from './tasks/form/create/TaskCreateScreen';

export class MyOutsourcesRouting extends React.Component {

    render() {
        const { currentUser } = this.props;

        if ( currentUser.isAdmin() ) {
            return (
                <React.Fragment>
                    <Route exact path={PsRoutes.MY_OUTSOURCES} component={OutsourcesScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DETAIL} component={OutsourceDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_ADD} component={AddOutsourceScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKS} component={WorkListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKS_ADD} component={WorkCreateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKS_DETAIL} component={WorkUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKERS} component={WorkerListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL} component={WorkerUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL} component={WorkerDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MACHINES} component={MachineListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL} component={MachineUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL} component={MachineDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS} component={DocumentsScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL} component={OutsourceDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT_CONFIRM} component={ExportOutsourceDocsConfirmScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT} component={ExportOutsourceDocsScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES} component={TypeDocumentsScreens}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES_DETAIL} component={TypeDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_SCHEMES} component={SchemesScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_SCHEMES_DETAIL} component={SchemesDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE} component={RemoveScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE_CONFIRM} component={RemoveConfirmScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PAPER_BIN_RECOVER} component={PaperBinScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MONTHLY} component={MonthlyScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY} component={MonthlyPresenceScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_TASKS} component={TasksScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_TASKS_ADD} component={TaskCreateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS} component={PresenceWorkListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL} component={PresenceAddScreen}/>
                </React.Fragment>
            );
        }

        if ( currentUser.isOutsourcesManager() ) {
            return (
                <React.Fragment>
                    <Route exact path={PsRoutes.MY_OUTSOURCES} component={OutsourcesScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DETAIL} component={OutsourceDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKS} component={WorkListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKS_ADD} component={WorkCreateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKS_DETAIL} component={WorkUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKERS} component={WorkerListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL} component={WorkerUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL} component={WorkerDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MACHINES} component={MachineListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL} component={MachineUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL} component={MachineDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS} component={DocumentsScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL} component={OutsourceDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT_CONFIRM} component={ExportOutsourceDocsConfirmScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT} component={ExportOutsourceDocsScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MONTHLY} component={MonthlyScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY} component={MonthlyPresenceScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_TASKS} component={TasksScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_TASKS_ADD} component={TaskCreateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS} component={PresenceWorkListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL} component={PresenceAddScreen}/>
                </React.Fragment>
            );
        }

        if ( currentUser.isOutsourcesViewer() ) {
            return (
                <React.Fragment>
                    {/*<Route exact path={PsRoutes.MY_OUTSOURCES_DETAIL} component={OutsourceUpdateScreen}/>*/}
                    <Route exact path={PsRoutes.MY_OUTSOURCES} component={OutsourcesScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DETAIL} component={OutsourceDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT_CONFIRM} component={ExportOutsourceDocsConfirmScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT} component={ExportOutsourceDocsScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKERS} component={WorkerListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL} component={WorkerUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL} component={WorkerDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MACHINES} component={MachineListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL} component={MachineUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL} component={MachineDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS} component={DocumentsScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL} component={OutsourceDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS} component={PresenceWorkListScreen}/>
                    <Route exact path={PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY} component={MonthlyPresenceScreen}/>
                </React.Fragment>
            );
        }

        return null;
    }
}

MyOutsourcesRouting.propTypes = {
    currentUser: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/MyOutsourcesRouting.jsx